import React from 'react';

import * as helpers from './helpers';

const DimensionsIcon = ({
  color,
  width = 24,
  height = 24,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg
    {...helpers.getSvgDimensionsProps({ width, height })}
    {...helpers.getViewBoxProperty({ width, height })}
    {...props}>
    <path
      d="M23.8125 11.625L23.625 11.4375L20.5781 8.67188C20.2969 8.42188 20.0312 8.42188 19.7812 8.67188L19.6406 8.85938C19.3906 9.07812 19.4219 9.32812 19.7344 9.60938L21.5156 11.25H12.7969V2.48438L14.4375 4.26562C14.7188 4.57812 14.9688 4.60938 15.1875 4.35938L15.375 4.21875C15.625 3.96875 15.625 3.70312 15.375 3.42188L12.75 0.515625C12.6562 0.390625 12.5469 0.296875 12.4219 0.234375V0.1875C12.2969 0.0625 12.1562 0 12 0C11.875 0 11.75 0.0625 11.625 0.1875L11.4375 0.375L8.71875 3.375C8.46875 3.65625 8.46875 3.92188 8.71875 4.17188L8.90625 4.3125C9.15625 4.5625 9.42188 4.53125 9.70312 4.21875L11.2969 2.4375V11.25H2.48438L4.26562 9.60938C4.57812 9.32812 4.60938 9.07812 4.35938 8.85938L4.21875 8.67188C3.96875 8.42188 3.70312 8.42188 3.42188 8.67188L0.515625 11.2969C0.390625 11.3906 0.296875 11.5 0.234375 11.625H0.1875C0.0625 11.75 0 11.8906 0 12.0469C0 12.1719 0.0625 12.2969 0.1875 12.4219L0.375 12.6094L3.375 15.3281C3.65625 15.5781 3.92188 15.5781 4.17188 15.3281L4.3125 15.1406C4.5625 14.8906 4.53125 14.625 4.21875 14.3438L2.4375 12.75H11.2969V21.5625L9.70312 19.7812C9.42188 19.4688 9.15625 19.4375 8.90625 19.6875L8.71875 19.8281C8.46875 20.0781 8.46875 20.3438 8.71875 20.625L11.4375 23.625L11.625 23.8125C11.75 23.9375 11.875 24 12 24C12.1562 24 12.2969 23.9375 12.4219 23.8125L12.6094 23.625L15.375 20.5781C15.625 20.2969 15.625 20.0312 15.375 19.7812L15.1875 19.6406C14.9688 19.3906 14.7188 19.4219 14.4375 19.7344L12.7969 21.5156V12.75H21.5625L19.7812 14.3438C19.4688 14.625 19.4375 14.8906 19.6875 15.1406L19.8281 15.3281C20.0781 15.5781 20.3438 15.5781 20.625 15.3281L23.625 12.6094L23.8125 12.4219C23.9375 12.2969 24 12.1719 24 12.0469C24 11.8906 23.9375 11.75 23.8125 11.625Z"
      fill={color}
    />
  </svg>
);

export default DimensionsIcon;
